export const ProductsEndpoints = {
  GET_ALL_PRODUCTS: '/api/admin/product',
  GET_LATEST_SYNC_STATUS: '/api/admin/product/sync/status',
  START_SYNC: '/api/admin/product/sync',
  GET_SYNC_RUNS: '/api/admin/product/sync/runs',
  GET_SYNC_RUN: (runId: number) => `/api/admin/product/sync/run/${runId}`,
  GET_RUN_QUEUE: (runId: number) => `/api/admin/product/sync/run/${runId}/queue`,
  FORCE_SYNC: '/api/admin/product/sync/force',
  GET_SYNC_HISTORY: '/api/admin/product/sync/history',
};
